import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../SEO'; // Import the SEO component
import cinnamonImage from '../assets/shop/อบเชยป่น-450x450.png';
import wholeSpicesImage from '../assets/shop/indian-whole-spices-500x500.webp';
import spicePowderImage from '../assets/shop/spices-seasoning-png-7.png';
import placeholderImage from '../assets/shop/download.jpeg';

function ShopNow() {
    const productCategories = [
        { name: 'Cinnamon', slug: 'cinnamon', image: cinnamonImage, alt: 'Cinnamon sticks' },
        { name: 'Whole Spices', slug: 'whole-spices', image: wholeSpicesImage, alt: 'Assorted whole spices' },
        { name: 'Spice Powders', slug: 'spice-powder', image: spicePowderImage, alt: 'Ground spice powder' }
    ];

    // SEO Structured Data
    const structuredData = {
        "@context": "https://schema.org",
        "@type": "CollectionPage",
        "name": "Shop Now - Galle Ceylon Spices International",
        "description": "Explore our premium Ceylon cinnamon, whole spices, and spice powders. Shop now for authentic Sri Lankan spices from Galle Ceylon Spices International.",
        "url": "https://www.galleceylonspices.com/shop-now",
        "image": "%PUBLIC_URL%/logo.png",
        "hasPart": productCategories.map(category => ({
            "@type": "CollectionPage",
            "name": category.name,
            "url": `https://www.galleceylonspices.com/order/${category.slug}`,
            "description": `Browse our collection of ${category.name.toLowerCase()} from Galle Ceylon Spices International.`,
            "image": category.image
        })),
        "publisher": {
            "@type": "Organization",
            "name": "Galle Ceylon Spices International (Pvt) Ltd",
            "logo": {
                "@type": "ImageObject",
                "url": "%PUBLIC_URL%/logo.png"
            },
            "address": {
                "@type": "PostalAddress",
                "streetAddress": "448/2, Nawadagala",
                "addressLocality": "Elpitiya",
                "postalCode": "80000",
                "addressCountry": "Sri Lanka"
            },
            "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "+94-77-929-1829",
                "contactType": "Customer Service",
                "contactOption": "WhatsApp",
                "areaServed": "Worldwide",
                "availableLanguage": "English"
            }
        }
    };

    return (
        <div className="container my-3 py-4">
            <SEO
                title="Shop Now - Galle Ceylon Spices International"
                description="Explore our premium Ceylon cinnamon, whole spices, and spice powders. Shop now for authentic Sri Lankan spices from Galle Ceylon Spices International."
                keywords="Ceylon cinnamon, whole spices, spice powders, Galle Ceylon Spices, Sri Lankan spices, shop spices"
                canonicalUrl="https://www.galleceylonspices.com/shop-now"
                ogImage="%PUBLIC_URL%/logo.png"
                structuredData={structuredData}
            />
            <h1
                className="text-center mb-4 fw-bold"
                style={{
                    color: '#355E3B',
                    fontFamily: 'Georgia',
                    fontSize: 'clamp(2rem, 5vw, 3.5rem)',
                    lineHeight: '1.2'
                }}
            >
                Shop Now
            </h1>
            <p
                className="text-center text-muted mb-4 lead"
                style={{
                    fontSize: 'clamp(1rem, 2.5vw, 1.3rem)',
                    maxWidth: '600px',
                    margin: '0 auto'
                }}
            >
                Start shopping for your favorite spices today.
            </p>

            <section
                className="py-4 animate__animated animate__fadeIn"
                style={{
                    backgroundColor: '#F9F9F9',
                    borderRadius: '12px',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                    animationDuration: '1s'
                }}
            >
                <h2
                    className="text-center mb-4 fw-bold"
                    style={{
                        color: '#355E3B',
                        fontFamily: 'Georgia',
                        fontSize: 'clamp(1.8rem, 4vw, 2.5rem)',
                        lineHeight: '1.2'
                    }}
                >
                    Explore Our Spice Categories
                </h2>
                <div className="row g-3 justify-content-center">
                    {productCategories.map((category, index) => (
                        <div className="col-12 col-md-6 col-lg-4 mb-3" key={index}>
                            <div
                                className="card h-100 border-0 shadow-sm category-card"
                                style={{ borderRadius: '12px', overflow: 'hidden' }}
                            >
                                <img
                                    src={category.image}
                                    alt={category.alt}
                                    className="card-img-top rounded-top-3"
                                    style={{
                                        height: 'clamp(200px, 30vw, 250px)',
                                        objectFit: 'cover'
                                    }}
                                    onError={(e) => (e.target.src = placeholderImage)}
                                    loading="lazy"
                                />
                                <div
                                    className="card-body d-flex flex-column p-3 bg-light"
                                    style={{ borderRadius: '0 0 12px 12px' }}
                                >
                                    <h5
                                        className="card-title text-center mb-3 text-dark fw-bold"
                                        style={{
                                            fontFamily: 'Georgia',
                                            fontSize: 'clamp(1.2rem, 2.5vw, 1.5rem)'
                                        }}
                                    >
                                        {category.name}
                                    </h5>
                                    <div className="mt-auto">
                                        <Link
                                            to={`/order/${category.slug}`}
                                            className="btn w-100 rounded-3 text-white category-link"
                                            aria-label={`Order ${category.name} now`}
                                            style={{
                                                fontSize: 'clamp(0.9rem, 2vw, 1.1rem)',
                                                backgroundColor: '#C19A6B',
                                                padding: '10px'
                                            }}
                                        >
                                            Order Now
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            {/* Inline CSS for styles and responsiveness */}
            <style>
                {`
                    .category-card {
                        transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
                    }
                    .category-card:hover {
                        transform: scale(1.03);
                        box-shadow: 0 6px 15px rgba(0, 0, 0, 0.2);
                    }
                    .category-card img {
                        transition: transform 0.4s ease-in-out;
                    }
                    .category-card:hover img {
                        transform: scale(1.1);
                    }
                    .category-link {
                        transition: all 0.3s ease-in-out;
                        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
                    }
                    .category-link:hover, .category-link:focus {
                        background-color: #A67B4D !important;
                        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
                    }
                    @media (max-width: 576px) {
                        .container.my-3 {
                            margin-top: 1rem !important;
                            margin-bottom: 1rem !important;
                        }
                        .container.py-4 {
                            padding-top: 1rem !important;
                            padding-bottom: 1rem !important;
                        }
                        .py-4 {
                            padding-top: 1rem !important;
                            padding-bottom: 1rem !important;
                        }
                        .mb-4 {
                            margin-bottom: 1rem !important;
                        }
                        .card-img-top {
                            height: 150px !important;
                        }
                        .card-body {
                            padding: 0.75rem !important;
                        }
                        .btn {
                            padding: 6px 12px !important;
                            font-size: 0.9rem !important;
                        }
                        h1 {
                            font-size: clamp(1.8rem, 4vw, 2.5rem) !important;
                        }
                        h2 {
                            font-size: clamp(1.5rem, 3.5vw, 2rem) !important;
                        }
                    }
                    @media (max-width: 576px) and (orientation: landscape) {
                        .card-img-top {
                            height: 120px !important;
                        }
                        .card-body {
                            padding: 0.5rem !important;
                        }
                        .btn {
                            padding: 4px 10px !important;
                            font-size: 0.8rem !important;
                        }
                    }
                    @media (min-width: 577px) and (max-width: 768px) {
                        .container.my-3 {
                            margin-top: 2rem !important;
                            margin-bottom: 2rem !important;
                        }
                        .container.py-4 {
                            padding-top: 2rem !important;
                            padding-bottom: 2rem !important;
                        }
                        .py-4 {
                            padding-top: 1.5rem !important;
                            padding-bottom: 1.5rem !important;
                        }
                        .mb-4 {
                            margin-bottom: 1.5rem !important;
                        }
                        .card-img-top {
                            height: 200px !important;
                        }
                    }
                    @media (min-width: 769px) and (max-width: 1024px) {
                        .container.my-3 {
                            margin-top: 2.5rem !important;
                            margin-bottom: 2.5rem !important;
                        }
                        .container.py-4 {
                            padding-top: 2.5rem !important;
                            padding-bottom: 2.5rem !important;
                        }
                        .py-4 {
                            padding-top: 2rem !important;
                            padding-bottom: 2rem !important;
                        }
                        .mb-4 {
                            margin-bottom: 2rem !important;
                        }
                        .card-img-top {
                            height: 220px !important;
                        }
                    }
                    @media (min-width: 1025px) {
                        .container.my-3 {
                            margin-top: 3rem !important;
                            margin-bottom: 3rem !important;
                        }
                        .container.py-4 {
                            padding-top: 3rem !important;
                            padding-bottom: 3rem !important;
                        }
                        .py-4 {
                            padding-top: 2.5rem !important;
                            padding-bottom: 2.5rem !important;
                        }
                        .mb-4 {
                            margin-bottom: 2.5rem !important;
                        }
                        .card-img-top {
                            height: 250px !important;
                        }
                    }
                `}
            </style>
        </div>
    );
}

export default ShopNow;